import React, { useEffect, useState } from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { showError } from "utils/notifications";
import FormSelect from "Common/Custom/FormSelect";

// Uses `fields` prop from parent — does not re-import JSON directly
const EditFloorAssignForm = ({
    fields = [],
    values,
    errors,
    handleChange,
    handleSubmit,
    loading,
    floorOptions = [],
    setValues,
}) => {
    const [roomNumbersArray, setRoomNumbersArray] = useState([]);

    // Auto-generate room numbers when no_of_room or start_no changes
    useEffect(() => {
        if (Array.isArray(values.room_numbers)) {
            setRoomNumbersArray(values.room_numbers);
        } else if (
            typeof values.room_numbers === "string" &&
            values.room_numbers.length
        ) {
            setRoomNumbersArray(
                values.room_numbers
                    .split(",")
                    .map((r) => r.trim())
                    .filter(Boolean)
            );
        }
    }, [values.room_numbers]);

    const generateRoomNumbers = () => {
        const totalRooms = Number(values.no_of_room);
        const startNo = Number(values.start_no);

        if (!totalRooms || totalRooms <= 0 || !startNo) {
            showError("Enter valid room count and start number");
            return;
        }

        const generatedRooms = Array.from(
            { length: totalRooms },
            (_, i) => String(startNo + i)
        );

        setRoomNumbersArray(generatedRooms);

        setValues((prev) => ({
            ...prev,
            room_numbers: generatedRooms,
        }));
    };

    const handleOnClickNumberOfRooms = (e) => {
        e.preventDefault();
        generateRoomNumbers();
    };

    const handleOnClickRemoveLastOne = (e) => {
        e.preventDefault();

        if (roomNumbersArray.length <= 1) {
            showError("At least one room number is required");
            return;
        }

        const updatedRooms = roomNumbersArray.slice(0, -1);
        setRoomNumbersArray(updatedRooms);
        setValues((prev) => ({
            ...prev,
            no_of_room: String(updatedRooms.length),
            room_numbers: updatedRooms,
        }));
    };

    return (
        <PageBody
            headerchildren={<HeadingOne>Edit Floor Assign</HeadingOne>}
            onSubmit={handleSubmit}
        >
            {fields.map((field) => {
                if (field.type === "button") {
                    return (
                        <div key={field.name} className={`pt-md-2 ${field.fieldSize || "col-12"}`}>
                            <button
                                type="button"
                                className="btn btn-primary mt-md-4 me-2"
                                onClick={handleOnClickNumberOfRooms}
                            >
                                Add Number Of Room
                            </button>
                            <button
                                type="button"
                                className="btn btn-danger mt-md-4 small"
                                onClick={handleOnClickRemoveLastOne}
                            >
                                <i className="fa fa-minus" />
                            </button>
                        </div>
                    );
                }

                if (field.name === "room_numbers") {
                    return roomNumbersArray.map((roomNo, index) => (
                        <FormInput
                            key={`${field.name}_${index}`}
                            field={{
                                ...field,
                                name: `${field.name}_${index}`,
                                label: `Room No ${index + 1}`,
                            }}
                            value={roomNo}
                            handleChange={(e) => {

                                const updatedRooms = [...roomNumbersArray];

                                updatedRooms[index] = e.target.value;

                                setRoomNumbersArray(updatedRooms);

                                setValues((prev) => ({
                                    ...prev,
                                    room_numbers: updatedRooms,
                                }));
                            }}
                            error={errors[`${field.name}_${index}`]}
                        />
                    ));
                }

                if (field.type === "select" && field.name === "floor_name") {
                    const options = floorOptions.map((opt) => ({
                        value: opt.floor_id,
                        label: opt.floor_name,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }

                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Update Floor Assign"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default EditFloorAssignForm;
